import { render, staticRenderFns } from "./markview.vue?vue&type=template&id=8a6cf6ea&scoped=true&"
import script from "./markview.vue?vue&type=script&lang=js&"
export * from "./markview.vue?vue&type=script&lang=js&"
import style0 from "./markview.vue?vue&type=style&index=0&id=8a6cf6ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6cf6ea",
  null
  
)

export default component.exports